import { defineStore } from 'pinia';

export const useSearchModalStore = defineStore('searchModal', {
  state: () => ({
    isOpen: false
  }),
  actions: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
});
